import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import { authenticatedFetch } from "../../utils/apiClient";

let isMounted = false;

export default withAuth(
  class Blacklist extends Component {
    constructor(props) {
      super(props);
      this.state = {
        persons: {}
      };
      this.addToBlacklist = this.addToBlacklist.bind(this);
      this.deleteFromBlacklist = this.deleteFromBlacklist.bind(this);
      this.getBlacklist = this.getBlacklist.bind(this);
      this.newBlackListEntry = this.newBlackListEntry.bind(this);
      this.addPublicCause = this.addPublicCause.bind(this);
      this.addCause = this.addCause.bind(this);
    }

    async componentDidMount() {
      isMounted = true;
      this.getBlacklist();
    }

    componentWillMount() {
      clearInterval(this.interval);
    }
    componentDidUpdate() {
      // Authentication is now handled by WithAuth HOC
    }

    componentWillUnmount() {
      isMounted = false;
    }

    async getBlacklist() {
      try {
        authenticatedFetch("/api/admin/getBlacklist", {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            pragma: "no-cache",
            "cache-control": "no-cache"
          }
        })
          .then(response => {
            return response.json();
          })
          .then(persondata => {
            this.setState({ persons: persondata });
          });
      } catch (err) {
        console.log(err);
      }
    }

    async newBlackListEntry() {
      let data = {};

      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";
      data.UpdatedBy = updatedBy;

      data.email = prompt("Hvem skal du blokkere? (epost)", "");
      if (data.email === null) {
        return;
      } else if (data.email.length < 1) {
        return;
      }
      if (
        window.confirm("Er du sikker på at du vil blokkere " + data.email + "?")
      ) {
        this.addPublicCause(data);
      } else {
        return;
      }
    }

    async addPublicCause(data) {
      data.publicCause = prompt(
        "Årsak til blokkering? (VISES OFFENTLIG FOR BRUKEREN)",
        ""
      );
      if (data.publicCause === null) {
        return;
      } else if (data.publicCause.length < 1) {
        return;
      }
      this.addCause(data);
    }

    async addCause(data) {
      data.cause = prompt(
        "Noe mer informasjon om blokkeringsårsak? (Vises kun internt)",
        ""
      );
      if (data.cause === null) {
        return;
      } else if (data.cause.length < 1) {
        return;
      }
      this.addToBlacklist(data);
    }

    async addToBlacklist(person) {
      person.email = person.email.toLowerCase();
      console.log(person);
      person.timeStamp = Date.now();
      try {
        authenticatedFetch("/api/admin/addToBlacklist", {
          method: "PUT",
          body: JSON.stringify(person),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }).then(response => {
          setTimeout(() => {
            this.getBlacklist();
          }, 1000);
        });
      } catch (err) {
        console.log(err);
      }
    }

    async deleteFromBlacklist(person) {
      try {
        authenticatedFetch("/api/admin/deleteFromBlacklist/" + person.email, {
          method: "PUT",
          body: JSON.stringify(person),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }).then(response => {
          setTimeout(() => {
            this.getBlacklist();
          }, 1000);
        });
      } catch (err) {
        console.log(err);
      }
    }

    render() {
      if (this.props.authenticated === null) return null;
      const personRows = [];
      for (let i = 0; i < this.state.persons.length; i++) {
        personRows.push(
          <tr key={i}>
            <td>{this.state.persons[i].email}</td>
            <td>{this.state.persons[i].publicCause}</td>
            <td>{this.state.persons[i].cause}</td>
            <td>
              {new Date(this.state.persons[i].timestamp).toLocaleString(
                "en-GB",
                {
                  timeZone: "UTC"
                }
              )}{" "}
            </td>
            <td>{this.state.persons[i].UpdatedBy} </td>
            <td>
              <button
                className="btn btn-danger help printHide"
                value={this.state.persons[i]}
                onClick={() => this.deleteFromBlacklist(this.state.persons[i])}
              >
                X
              </button>
            </td>
          </tr>
        );
      }

      return (
        <div className="SignupList">
          <h1>Blacklist</h1>
          <br />
          <button
            className={
              "btn btno edit printHide " +
              (this.state.editMode ? "btn-info" : "btn-danger")
            }
            onClick={this.newBlackListEntry}
          >
            {this.state.editMode ? "Lås" : "Legg til"}
          </button>
          <button
            className="btn btno btn-success edit printHide "
            onClick={() => this.getBlacklist()}
          >
            Oppdater
          </button>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Epost</th>
                <th>Offentlig årsak</th>
                <th>Intern notat/årsak</th>
                <th>Tidspunkt</th>
                <th>Oppdatert av</th>
                <th>Slett</th>
              </tr>
            </thead>
            <tbody>{personRows}</tbody>
          </table>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Components/Admin/Blacklist.js